import { Box, Input, Typography } from "@mui/material";
import React from "react";
import { usePathContext } from "../PathInfo";
import { useTreeModifyContext } from "../TreeDataContext";

export function ScaleMultEditor(props: { scaleMult: number }) {
  const { path } = usePathContext();
  const { saveChangesAtPath } = useTreeModifyContext();

  function onScaleMultChanged(newScaleMult: number) {
    saveChangesAtPath(newScaleMult, path);
  }

  return (
    <Box className="horizontal-flex">
      <Typography>Scale multiplier:&nbsp;</Typography>
      <Input
        id="scale-mult"
        slotProps={{ input: { type: "number", min: 0, step: 0.1, max: 100 } }}
        onChange={(e) => {
          let value = parseFloat(e.target.value);
          if (value !== undefined) {
            onScaleMultChanged(value);
          }
        }}
        value={props.scaleMult}
      />
    </Box>
  );
}
